class CaptchaLimitHandler {
  private static instance: CaptchaLimitHandler;

  private captchaLimitCounter: Record<string, number>;

  private constructor() {
    this.captchaLimitCounter = {};
  }

  static getInstance() {
    if (!CaptchaLimitHandler.instance) CaptchaLimitHandler.instance = new CaptchaLimitHandler();
    return CaptchaLimitHandler.instance;
  }

  addUsage(url: string) {
    if (!this.captchaLimitCounter[url]) {
      this.captchaLimitCounter[url] = 2;
      return;
    }
    this.captchaLimitCounter[url] += 1;
  }

  reset(url: string) {
    this.captchaLimitCounter[url] = 0;
  }

  getUsage(url: string) {
    return this.captchaLimitCounter[url];
  }
}

export default CaptchaLimitHandler;
export { CaptchaLimitHandler };
